import { render, staticRenderFns } from "./DeleteInvitationPopup.vue?vue&type=template&id=e81a4dfa&scoped=true&"
import script from "./DeleteInvitationPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteInvitationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteInvitationPopup.vue?vue&type=style&index=0&id=e81a4dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81a4dfa",
  null
  
)

export default component.exports